import React, { useEffect, useState, useRef } from "react";
import clsx from "clsx";
import nl2br from "react-nl2br";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { Helmet } from "react-helmet";
import { Link, withPrefix } from "gatsby";
import favicon from "../../images/favicon.ico";
import eduhkLogo from "../../images/eduhklogo.png";
import fairBox from "../../images/fair-box.png";
import fairLogo from "../../images/fair-logo.png";
import eieuLogo from "../../images/eieu-logo.png";
import eduhkBwLogo from "../../images/eduhk-logo-60.png";
import libBwLogo from "../../images/eduhklib-logo-60.png";
import eieuBwLogo from "../../images/eieu-logo-60.png";
import orgUnitLib from "../../images/EdUHK_4C-705x188.jpeg";
import orgUnitEieu from "../../images/EIEULogo-300x150.png";
import sponsorD2 from "../../images/d2place-logo.png";
import supportAado from "../../images/aado-logo.png";
import supportCrse from "../../images/crse-logo.jpeg";
import supportFehd from "../../images/FEHD_logo1_4C_May2014.jpg";
import supportFhm from "../../images/fhm-logo.png";
import supportFlass from "../../images/FLASS_Logo_Version_A.jpg";
import supportHkme from "../../images/hkme-logo.png";
import supportKtso from "../../images/ktso-logo.png";
import supportSao from "../../images/sao-logo.png";
import supportSpfeo from "../../images/spfeo-logo.png";
import AwardsStudents from "../../components/awards/students";
import stallsData from "../../stalls.json";

export default function Home({ children, location }) {
  const [stalls, setStalls] = useState(stallsData);
  const [stallKeyword, setStallKeyword] = useState("");
  const [activeStall, setActiveStall] = useState(null);
  const [showPopup, setShowPopup] = useState(true);

  const filterStalls = (e) => {
    e.preventDefault();

    if (stallKeyword === "") {
      setStalls(stallsData);
    } else {
      setStalls(
        stallsData.filter((stall) => {
          return (
            stall.stall_no.toLowerCase().includes(stallKeyword) ||
            stall.name.toLowerCase().includes(stallKeyword)
          );
        })
      );
    }

    return false;
  };

  const zones = [
    {
      zone: "A",
      name: "創業大吉文創區",
    },
    {
      zone: "B",
      name: "豐衣足食衣飾區",
    },
    {
      zone: "C",
      name: "生龍活虎生活區",
    },
    {
      zone: "D",
      name: "大展身手手工坊",
    },
  ];

  const dismissStallOverlay = (e) => {
    if (e.target.id === "stall-overlay") {
      setActiveStall(null);
    }
  };

  const dismissPopupOverlay = (e) => {
    if (e.target.id === "popup-overlay") {
      setShowPopup(false);
    }
  };

  return (
    <div>
      <Helmet>
        <title>2022 學生市集 – 教大年宵</title>
        <link rel="icon" href={favicon} />
      </Helmet>
      <header>
        <div className="mx-auto px-2 py-2 lg:px-14 lg:py-0">
          <div className="flex justify-between items-center lg:py-2 lg:my-1">
            <div className="flex items-center">
              <div className="mr-4 flex items-center">
                <a href="https://eieu.lib.eduhk.hk">
                  <img src={eieuLogo} style={{ height: "80px" }} alt="EIEU" />
                </a>
              </div>
            </div>
            <div className="lg:hidden mr-2">
              <Link to="/">Eng</Link>
            </div>
            <div className="lg:flex lg:items-center hidden">
              <ScrollLink
                to="about"
                smooth={true}
                duration={500}
                className="cursor-pointer hover:text-red-600 font-semibold text-lg ml-8"
              >
                關於教大年宵
              </ScrollLink>
              <ScrollLink
                to="stalls"
                smooth={true}
                duration={500}
                className="cursor-pointer hover:text-red-600 font-semibold text-lg ml-8"
              >
                年宵攤位
              </ScrollLink>
              <ScrollLink
                to="awards"
                smooth={true}
                duration={500}
                className="cursor-pointer hover:text-red-600 font-semibold text-lg ml-8"
              >
                獎項
              </ScrollLink>

              <span className="ml-8 font-bold">|</span>

              <Link
                to="/"
                className="cursor-pointer hover:text-red-600 text-lg ml-8"
              >
                Eng
              </Link>
            </div>
          </div>
        </div>
      </header>
      <div className="hero-wrap">
        <div class="hero flex flex-col justify-center items-center"></div>
      </div>
      <main>
        <div id="about" className="lg:py-20 py-10">
          <div className="container mx-auto px-4 lg:px-0">
            <div className="lg:flex">
              <div className="lg:flex-1 lg:pr-10">
                <h5 className="text-red-400">#about</h5>
                <h3 className="lg:text-3xl text-xl font-bold">關於教大年宵</h3>
                <p className="leading-loose mt-3">
                  「2022學生市集 –
                  教大年宵」將於年二十、廿一（2022年1月22及23日，星期六及日）在D2
                  Place舉行，讓教大同學可以透過親身參與，發展和體驗企業和創新精神。同學可以嘗試經營自己的小生意，並向業界專家學習。「2022學生市集」市集獲教大校友、各中小學及其家長教師會、非政府組織及社會企業的支持和參與，設有百個攤位，售賣商品包括原創手工藝品、文具、各樣年貨、花卉、布藝飾物等，更設有各式各樣的藝術工作坊和親子工作坊，是一個充滿學院氣息和文藝創意的年宵市集，大家絕對不容錯過！
                </p>
                <div class="flex lg:items-center mt-3 bg-yellow-50 shadow-lg rounded p-3">
                  <div class="flex-1">
                    <p>
                      <label className="font-bold uppercase">日期</label>
                    </p>
                    <p>
                      2022 年 1 月 22 日上午 11:30 至晚上 8 時
                      <br />
                      2022 年 1 月 23 日上午 11:00 至晚上 8 時
                    </p>
                  </div>
                  <div class="flex-1 flex justify-between items-center lg:ml-0 ml-4">
                    <div>
                      <p>
                        <label className="font-bold uppercase">地點</label>
                      </p>
                      <p>
                        茘枝角
                        <br />
                        The Space, 2/F@D2 Place ONE (D2出口)
                      </p>
                      <a
                        href="http://www.d2place.com/location"
                        className="text-blue-600 underline lg:hidden"
                        target="_blank"
                      >
                        前往方法
                      </a>
                    </div>
                    <a
                      class="cta lg:inline-block hidden"
                      href="http://www.d2place.com/location"
                      target="_blank"
                    >
                      <svg
                        class="w-5 h-5 inline-block mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        ></path>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                      </svg>
                      前往方法
                    </a>
                  </div>
                </div>
              </div>
              {/* <div className="lg:w-1/3 my-auto">
                <div className="lg:mt-0 mt-8 text-right">
                  <img
                    src={fairBox}
                    width="300"
                    height="200"
                    alt=""
                    className="mx-auto"
                  />
                </div>
              </div> */}
            </div>

            <div className="mt-8">
              <p className="font-bold text-lg">資助機構:</p>
              <ul className="flex items-center mt-2">
                <li className="mr-3 mb-2">
                  <a
                    href="https://www.ugc.edu.hk/eng/ugc/index.html"
                    target="_blank"
                    rel="noreferrer"
                    className="block px-2 py-1 text-sm text-center"
                  >
                    大學教育資助委員會
                    <br />
                    University Grants Committee
                  </a>
                </li>
              </ul>

              <p className="font-bold mt-3 text-lg">主辦單位:</p>
              <div class="grid grid-cols-2 lg:grid-cols-6 gap-4 mt-2">
                <a
                  href="https://www.lib.eduhk.hk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={orgUnitLib}
                    class="h-12 object-contain"
                    alt="EdUHK Library"
                  />
                </a>
                <a
                  href="https://eieu.lib.eduhk.hk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={orgUnitEieu}
                    class="h-12 object-contain"
                    alt="EIEU"
                  />
                </a>
              </div>

              <p className="font-bold mt-3 text-lg">贊助機構/人士:</p>
              <ul className="flex items-center mt-2">
                <li className="mr-3 mb-2">
                  <a
                    href="http://www.d2place.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src={sponsorD2} style={{ height: "40px" }} />
                  </a>
                </li>
                <li className="mr-3 mb-2">
                  <div className="px-2 py-1 text-sm text-center">
                    陳錦泉先生
                    <br />
                    Mr Andrew Chan
                  </div>
                </li>
              </ul>

              <p className="font-bold mt-3 text-lg">協辦單位:</p>
              <div class="grid grid-cols-2 lg:grid-cols-6 gap-4 mt-2">
                <a
                  href="https://www.eduhk.hk/aado"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportAado}
                    style={{ height: "40px" }}
                    alt="Alumni Affairs and Development Office"
                  />
                </a>
                <a
                  href="https://www.eduhk.hk/co"
                  target="_blank"
                  rel="noreferrer"
                  className="block px-2 py-1 text-sm text-center"
                >
                  傳訊處
                  <br />
                  Communications Office
                </a>
                <a
                  href="https://www.eduhk.hk/crse"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportCrse}
                    style={{ height: "40px" }}
                    alt="Centre for Religious and Spirituality Education"
                  />
                </a>
                <a
                  href="https://www.eduhk.hk/fehd"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportFehd}
                    style={{ height: "40px" }}
                    alt="Faculty of Education and Human Development"
                  />
                </a>
                <a
                  href="https://www.eduhk.hk/fhm"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportFhm}
                    style={{ height: "40px" }}
                    alt="Faculty of Humanities"
                  />
                </a>
                <a
                  href="https://www.eduhk.hk/flass"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportFlass}
                    style={{ height: "60px" }}
                    alt="Faculty of Liberal Arts and Social Sciences"
                  />
                </a>
                <a
                  href="https://www.eduhk.hk/fo"
                  target="_blank"
                  rel="noreferrer"
                  className="block px-2 py-1 text-sm text-center"
                >
                  財務處
                  <br />
                  Finance Office
                </a>
                <a
                  href="https://www.museum.eduhk.hk"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportHkme}
                    style={{ height: "40px" }}
                    alt="Hong Kong Museum of Education"
                  />
                </a>
                <a
                  href="https://www.eduhk.hk/rdo/KnowledgeTransfer"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportKtso}
                    style={{ height: "40px" }}
                    alt="Knowledge Transfer Sub-office"
                  />
                </a>
                <a
                  href="https://www.eduhk.hk/sao"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportSao}
                    style={{ height: "40px" }}
                    alt="Student Affairs Office"
                  />
                </a>
                <a
                  href="https://www.eduhk.hk/spfeo"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={supportSpfeo}
                    style={{ height: "40px" }}
                    alt="School Partnership and Field Experience Office"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div id="news" className="lg:py-20 py-10 relative bg-gray-50">
          <div className="container mx-auto px-4 lg:px-0">
            <h5 className="text-orange-600">#updates</h5>
            <h3 className="lg:text-3xl text-xl font-bold">最新消息</h3>

            <p className="mt-5">「最佳銷售計劃書」獎項得獎學生資料如下。</p>

            <table class="w-full bg-white table-auto my-3">
              <thead>
                <tr>
                  <th
                    width="20%"
                    class="border border-black px-2 py-2 text-left"
                  >
                    Group
                  </th>
                  <th
                    width="30%"
                    class="border border-black px-2 py-2 text-left"
                  >
                    Name
                  </th>
                  <th
                    width="50%"
                    class="border border-black px-2 py-2 text-left"
                  >
                    Programme of Study
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border border-black px-2 py-2">Student</td>
                  <td class="border border-black px-2 py-2">Cheung Kwan Yuk</td>
                  <td class="border border-black px-2 py-2">
                    Bachelor of Arts (Honours) in Creative Arts and Culture and
                    Bachelor of Education (Honours) (Visual Arts)
                  </td>
                </tr>
                <tr>
                  <td class="border border-black px-2 py-2">Alumni</td>
                  <td class="border border-black px-2 py-2">Chow Wing Yee</td>
                  <td class="border border-black px-2 py-2">
                    Bachelor of Arts (Honours) in Creative Arts and Culture
                    (Visual Arts)
                  </td>
                </tr>
                <tr>
                  <td class="border border-black px-2 py-2">Student</td>
                  <td class="border border-black px-2 py-2">Ling Man Yue</td>
                  <td class="border border-black px-2 py-2">
                    Bachelor of Arts (Honours) in Creative Arts and Culture and
                    Bachelor of Education (Honours) (Visual Arts)
                  </td>
                </tr>
                <tr>
                  <td class="border border-black px-2 py-2">Student</td>
                  <td class="border border-black px-2 py-2">
                    Luk Hoi Nam Yvette
                  </td>
                  <td class="border border-black px-2 py-2">
                    Bachelor of Arts (Honours) in Creative Arts and Culture and
                    Bachelor of Education (Honours) (Visual Arts)
                  </td>
                </tr>
                <tr>
                  <td class="border border-black px-2 py-2">Student</td>
                  <td class="border border-black px-2 py-2">Ngai Wing Lam</td>
                  <td class="border border-black px-2 py-2">
                    Bachelor of Arts (Honours) in Creative Arts and Culture and
                    Bachelor of Education (Honours) (Visual Arts)
                  </td>
                </tr>
                <tr>
                  <td class="border border-black px-2 py-2">Student</td>
                  <td class="border border-black px-2 py-2">Ng Sau Ching</td>
                  <td class="border border-black px-2 py-2">
                    Bachelor of Arts (Honours) in Creative Arts and Culture and
                    Bachelor of Education (Honours) (Visual Arts)
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div id="stalls" className="lg:py-20 py-10 relative">
          <div className="container mx-auto px-4 lg:px-0">
            <div className="flex justify-between items-center">
              <div>
                <h5 className="text-orange-600">#stalls</h5>
                <h3 className="lg:text-3xl text-xl font-bold">年宵攤位</h3>
              </div>
              <div>
                <form className="relative" onSubmit={filterStalls}>
                  <input
                    type="text"
                    value={stallKeyword}
                    onChange={(e) => setStallKeyword(e.target.value)}
                    className="border focus:outline-none rounded-full px-4 py-2 border-black"
                    placeholder="搜尋攤位"
                  />
                  <button className="focus:outline-none absolute right-0 top-1/2 -mt-3 mr-3">
                    <svg
                      class="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      ></path>
                    </svg>
                  </button>
                </form>
              </div>
            </div>

            <p className="mt-3 mb-3">
              <a
                href={withPrefix("/TheSpace_Floorplan_v8.jpg")}
                target="_blank"
                rel="noreferrer"
                className="underline text-blue-600"
              >
                查看年宵平面圖
              </a>
            </p>

            <div className="mt-5">
              {zones.map((zone, z) => {
                const stallsInZone = stalls.filter((stall) => {
                  return stall.stall_no.substring(0, 1) === zone.zone;
                });
                var bg = "";
                var icon = "";
                if (zone.zone == "A") {
                  bg = "bg-yellow-100";
                  icon = "text-yellow-500";
                } else if (zone.zone == "B") {
                  bg = "bg-green-100";
                  icon = "text-green-500";
                } else if (zone.zone == "C") {
                  bg = "bg-pink-100";
                  icon = "text-pink-500";
                } else if (zone.zone == "D") {
                  bg = "bg-blue-100";
                  icon = "text-blue-500";
                }
                return stallsInZone.length === 0 ? (
                  <div />
                ) : (
                  <div className="mb-20">
                    <h3 className="font-bold text-lg mb-4">
                      <span>{zone.zone}區:</span> {zone.name}
                    </h3>
                    <div
                      key={z}
                      className="grid grid-cols-2 lg:grid-cols-4 gap-4"
                    >
                      {stallsInZone.map((stall, i) => {
                        return stall.enabled ? (
                          <button
                            key={i}
                            onClick={() => setActiveStall(stall)}
                            className={clsx(
                              "relative block border border-gray-500 px-4 py-2 rounded-lg",
                              bg
                            )}
                          >
                            <h5 className="text-center text-lg font-semibold">
                              {stall.name}
                            </h5>
                            <p className="text-center">{stall.stall_no}</p>
                            {stall.photos > 0 && (
                              <svg
                                className={clsx(
                                  "w-5 h-5 absolute bottom-0 right-0 mr-2 mb-3",
                                  icon
                                )}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                ></path>
                              </svg>
                            )}
                          </button>
                        ) : (
                          <button
                            key={i}
                            className={clsx(
                              "block border border-dashed border-gray-500 px-4 py-2 rounded-lg pointer-events-none bg-white"
                            )}
                          >
                            <h5 className="text-center text-lg font-semibold">
                              {stall.name}
                            </h5>
                            <p className="text-center">{stall.stall_no}</p>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div id="awards" className="lg:py-20 py-10 bg-gray-50 relative">
          <div className="container mx-auto px-4 lg:px-0">
            <h5 className="text-orange-600">#awards</h5>
            <h3 className="lg:text-3xl text-xl font-bold">獎項</h3>

            <p className="mt-5">此部分只適用教大學生。</p>

            <div className="bg-white mt-5 shadow-lg">
              <div className="bg-gray-800">
                <button className="lg:px-6 px-4 py-4 text-white bg-red-600">
                  教大學生
                </button>
              </div>
              <div className="guidelines lg:px-8 lg:py-8 px-4 py-4">
                <AwardsStudents />
              </div>
            </div>
          </div>
        </div>
      </main>

      <footer className="bg-black py-10 px-10 md:py-20 md:px-20">
        <div className="container mx-auto">
          <div className="flex items-center justify-center">
            <div className="text-white">
              <p className="text-orange-400 mb-3 font-semibold text-center">
                聯絡我們
              </p>
              <p className="text-center">香港教育大學圖書館企業及創新教育組</p>
              <p className="text-center">電話: 29486511</p>
              <p className="text-center">
                電郵:{" "}
                <a href="mailto:eieu@eduhk.hk" className="underline">
                  eieu@eduhk.hk
                </a>
              </p>
              <ul className="mt-6 list-style-none flex items-center justify-center">
                <li className="mr-6">
                  <a
                    href="https://www.eduhk.hk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="opacity-50 hover:opacity-100"
                      src={eduhkBwLogo}
                      width="30"
                      height="20"
                      alt="EdUHK"
                    />
                  </a>
                </li>
                <li className="mr-6">
                  <a
                    href="https://www.lib.eduhk.hk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="opacity-50 hover:opacity-100"
                      src={libBwLogo}
                      width="30"
                      height="20"
                      alt="EdUHK Library"
                    />
                  </a>
                </li>
                <li>
                  <a
                    href="https://eieu.lib.eduhk.hk"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="opacity-50 hover:opacity-100"
                      src={eieuBwLogo}
                      width="40"
                      height="20"
                      alt="EIEU"
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {showPopup && (
        <div
          id="popup-overlay"
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={dismissPopupOverlay}
        >
          <div className="relative bg-white lg:w-1/2 rounded-lg overflow-y-scroll">
            <div className="px-6 lg:px-10 py-8">
              <div className="flex items-center justify-between mb-5">
                <h3 className="text-xl font-bold">Latest News 最新消息</h3>
                <button
                  className="focus:outline-none"
                  onClick={() => setShowPopup(false)}
                >
                  <svg
                    class="w-12 h-12 text-gray-400 hover:text-gray-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </div>

              <p>
                Due to the latest pandemic situation, we regret to announce that
                “2022 Student Fair – EdUHK Lunar New Year Fair” scheduled on 22
                & 23 January 2022 at D2 Place is officially canceled. We would
                like to express our sincere gratitude to our sponsors Mr Andrew
                Chan and D2 Place, all supporting units as well as all
                participating students, alumni, schools and organisations for
                their support to 2022 Student Fair. “2022 Online Student Fair –
                EdUHK Lunar New Year Fair” is now open for public access,
                displaying products provided by EdUHK students and alumni from
                now until 28 February 2022 as an online substitute. “2022 Online
                Student Fair” includes a wide variety of Chinese New Year
                products, original artworks and handcrafts, stationery,
                clothing, accessories, plants, etc. “2022 Online Student Fair”
                can be accessed at{" "}
                <a
                  href="https://eieu.lib.eduhk.hk/events/fair-2022/online-market"
                  className="text-blue-600 hover:text-blue-700"
                >
                  https://eieu.lib.eduhk.hk/events/fair-2022/online-market
                </a>
                .
              </p>

              <p className="mt-4">
                因應最新疫情，原訂於2022年1月22及23日在D2
                Place舉行的「2022學生市集 –
                教大年宵」現已正式取消。我們衷心感謝兩位贊助人陳錦泉先生及D2
                Place、各協辦單位，以及所有參加同學、校友、學校和機構對市集的支持。「2022網上學生市集」現已開放，作為線上替代方案，由即日起至2022年2月28日，展示由教大同學和校友提供的各種商品，包括年貨、原創手工藝品、文具、花卉、布藝飾物等。各位可以登入以下網址，參觀「2022網上學生市集」各間網店：
                <a
                  href="https://eieu.lib.eduhk.hk/events/fair-2022/online-market/tc"
                  className="text-blue-600 hover:text-blue-700"
                >
                  https://eieu.lib.eduhk.hk/events/fair-2022/online-market/tc
                </a>
                。
              </p>
            </div>
          </div>
        </div>
      )}

      {activeStall && (
        <div
          id="stall-overlay"
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={dismissStallOverlay}
        >
          <div className="relative bg-white w-full h-full lg:w-3/4 lg:h-3/4 rounded-lg overflow-y-scroll">
            <div className="px-10 py-8">
              <div className="flex items-center justify-between">
                <div>
                  <h5 className="text-red-400 mb-1">
                    攤位編號 {activeStall.stall_no}
                    {activeStall.org && (
                      <span className="inline-block ml-4">
                        (by {activeStall.org})
                      </span>
                    )}
                  </h5>
                  <h3 className="lg:text-3xl text-xl font-bold">
                    {activeStall.name}
                  </h3>
                </div>
                <button
                  className="focus:outline-none"
                  onClick={() => setActiveStall(null)}
                >
                  <svg
                    class="w-12 h-12 text-gray-400 hover:text-gray-700"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </div>

              <div className="mt-5 leading-relaxed">
                {nl2br(activeStall.desc)}

                {activeStall.photos > 0 && (
                  <div className="mt-5">
                    <h5 className="font-bold mb-4 text-lg">產品相片</h5>
                    <div className="grid grid-cols-2 lg:grid-cols-8 gap-4">
                      {[...Array(activeStall.photos)].map((j, i) => (
                        <a
                          key={i}
                          href={withPrefix(
                            `/stalls/${activeStall.id}/pic${i + 1}.jpg`
                          )}
                          target="_blank"
                        >
                          <img
                            src={withPrefix(
                              `/stalls/${activeStall.id}/pic${i + 1}.jpg`
                            )}
                            className="h-32 w-full object-cover"
                          />
                        </a>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
